import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import LinearProgress from '@material-ui/core/LinearProgress'
import { makeStyles } from '@material-ui/core/styles'
import { STRIPE_CUSTOMER_PORTAL_URL } from 'env'
import { useUpgradeFlow } from 'lib/hooks/use-upgrade-flow'
import UpgradeSuccessModal from 'components/upgrade-success-modal'

const useStyles = makeStyles(theme => ({
  coachPlusSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2.5),
    padding: theme.spacing(3),
    backgroundColor: '#E0EAFF',
    border: '1px solid #C5D4FF',
    borderRadius: 12,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  coachPlusCopy: {
    minWidth: 0,
  },
  planLabel: {
    fontSize: '0.6875rem',
    fontWeight: 500,
    letterSpacing: '0.08em',
    lineHeight: 1.3,
    textTransform: 'uppercase',
    color: '#6B7C87',
    marginBottom: theme.spacing(0.75),
  },
  coachPlusTitle: {
    fontWeight: 700,
    fontSize: '1.125rem',
    lineHeight: 1.3,
    color: '#00205B',
    marginBottom: theme.spacing(0.75),
  },
  coachPlusCaption: {
    fontSize: '0.875rem',
    lineHeight: 1.5,
    color: '#172024',
    maxWidth: 520,
  },
  coachPlusButton: {
    borderRadius: 20,
    textTransform: 'none',
    fontWeight: 700,
    fontSize: '0.9375rem',
    padding: theme.spacing(1.25, 3.5),
    whiteSpace: 'nowrap',
    flexShrink: 0,
    boxShadow: 'none',
    '&:hover': {
      boxShadow: '0 4px 12px rgba(0, 83, 255, 0.28)',
    },
  },
}))

const SubscriptionDetails = () => {
  const classes = useStyles()
  const {
    hasPaidTier: hasPaidTierSubscription,
    showSuccessModal,
    upgradeLoading: loading,
    handleUpgradeClick,
    handleDismiss,
  } = useUpgradeFlow('subscription-details')

  return (
    <>
      {loading && <LinearProgress />}
      <Box className={classes.coachPlusSection}>
        <Box className={classes.coachPlusCopy}>
          <Typography className={classes.planLabel}>Your plan</Typography>
          <Typography className={classes.coachPlusTitle}>
            {hasPaidTierSubscription ? 'PGA Coach+' : 'PGA Coach'}
          </Typography>
          <Typography className={classes.coachPlusCaption}>
            {hasPaidTierSubscription
              ? 'Manage billing and payment details for your PGA Coach+ subscription anytime.'
              : 'Upgrade to PGA Coach+ for featured placement, premium profile tools, and insights to grow your business.'}
          </Typography>
        </Box>
        {hasPaidTierSubscription ? (
          <Button
            variant="contained"
            color="primary"
            target="_blank"
            href={STRIPE_CUSTOMER_PORTAL_URL}
            className={classes.coachPlusButton}
          >
            Manage Plan
          </Button>
        ) : (
          <Button
            variant="contained"
            color="primary"
            onClick={handleUpgradeClick}
            className={classes.coachPlusButton}
          >
            Upgrade Now
          </Button>
        )}
      </Box>

      <UpgradeSuccessModal isOpen={showSuccessModal} onClose={handleDismiss} />
    </>
  )
}

export default SubscriptionDetails
